"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAIT_TIME = exports.SLIDE_CLASSNAME = exports.SLIDES_PER_VIEW_DEFAULT_VALUE = exports.SLIDER_CLASSNAME = exports.PAGINATION_MOBILE_MARGIN = exports.PAGINATION_DESKTOP_MARGIN = exports.MAX_VISIBLE_PAGINATION_ITEMS = exports.LAST_SLIDE_THRESHOLD = exports.ACTIVE_SLIDE_CLASSNAME = void 0;
const SLIDES_PER_VIEW_DEFAULT_VALUE = exports.SLIDES_PER_VIEW_DEFAULT_VALUE = 1;
const LAST_SLIDE_THRESHOLD = exports.LAST_SLIDE_THRESHOLD = 0.95;
const WAIT_TIME = exports.WAIT_TIME = 100;
const SLIDER_CLASSNAME = exports.SLIDER_CLASSNAME = 'keen-slider';
const SLIDE_CLASSNAME = exports.SLIDE_CLASSNAME = `${SLIDER_CLASSNAME}__slide`;
const ACTIVE_SLIDE_CLASSNAME = exports.ACTIVE_SLIDE_CLASSNAME = 'active-slide';
const MAX_VISIBLE_PAGINATION_ITEMS = exports.MAX_VISIBLE_PAGINATION_ITEMS = 8;
const PAGINATION_MOBILE_MARGIN = exports.PAGINATION_MOBILE_MARGIN = 4;
const PAGINATION_DESKTOP_MARGIN = exports.PAGINATION_DESKTOP_MARGIN = 8;
//# sourceMappingURL=constants.js.map